// extracted by mini-css-extract-plugin
export default {"column":"leftpanel_column__TNPjf","columnlist":"leftpanel_columnlist__C2mu5","panel_head":"leftpanel_panel_head__HXtvo","test":"leftpanel_test__bnzg6"};